import { Injectable, computed, effect, inject, signal } from '@angular/core';
import { TranslationService } from '../../../core/i18n';
import { AppConfigService } from '../shell-hero/app-config.service';
import { nextMaintenanceBannerTransition, resolveMaintenanceBanner } from './maintenance-banner';

const MAX_TIMEOUT_MS = 2_147_483_647;

@Injectable({ providedIn: 'root' })
export class MaintenanceBannerService {
  private readonly appConfig = inject(AppConfigService);
  private readonly translation = inject(TranslationService);
  private readonly now = signal(new Date());

  readonly banner = computed(() =>
    resolveMaintenanceBanner(
      this.appConfig.config()?.maintenanceBanner,
      this.translation.locale() === 'fr' ? 'fr' : 'en',
      this.now(),
    ),
  );

  constructor() {
    effect((onCleanup) => {
      const currentTime = this.now();
      const nextTransition = nextMaintenanceBannerTransition(
        this.appConfig.config()?.maintenanceBanner,
        currentTime,
      );
      if (nextTransition === null) {
        return;
      }

      const delay = Math.min(Math.max(nextTransition - currentTime.getTime(), 0), MAX_TIMEOUT_MS);
      const timeout = setTimeout(() => this.now.set(new Date()), delay);
      onCleanup(() => clearTimeout(timeout));
    });
  }
}
